import categoryItems from '@/controllers/library/category-items.js';

export default {
  extends: categoryItems,
}
